module.exports = __webpack_public_path__ + "img/title.1d2f1cd4.png";